import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { InjectComponentDirective } from '../inject-component.directive';
import { Form, PersonForm } from '../model/form';
import { SettingsService } from '../settings.service';
import { UserFeedbackService } from '../user-feedback.service';

export interface FormDialogData {
  form: Form;
  objectService: any;
  title?: string;
}

/**
 * Generic dialog wrapper around the app's dynamically-injected Form
 * components (UserForm/InviteUserForm/PersonForm/...).
 */
@Component({
  selector: 'app-form-dialog',
  templateUrl: './form-dialog.component.html',
  styleUrls: ['./form-dialog.component.css'],
})
export class FormDialogComponent implements OnInit, OnDestroy {

  @ViewChild(InjectComponentDirective, { static: true }) view!: InjectComponentDirective;

  constructor(
    public dialogRef: MatDialogRef<FormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FormDialogData,
    private formBuilder: FormBuilder,
    private userFeedbackService: UserFeedbackService,
    private translateService: TranslateService,
    private settingsService: SettingsService,
  ) {
    this.dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.data.form.addListener(this);

    const componentType = this.data.form.componentRef;
    if (!componentType) return;

    const vcr = this.view.viewContainerRef;
    vcr.clear();
    const componentRef = vcr.createComponent(componentType);
    componentRef.instance.data = this.data.form;
    componentRef.instance.formBuilder = this.formBuilder;
    componentRef.instance.userFeedbackService = this.userFeedbackService;
    componentRef.instance.translateService = this.translateService;
    componentRef.instance.objectService = this.data.objectService;
    if (this.data.form.className === PersonForm.className && componentRef.instance.setSettingsService) {
      componentRef.instance.setSettingsService(this.settingsService);
    }
  }

  ngOnDestroy(): void {
    this.data.form.removeListener(this);
  }

  get dialogTitle(): string {
    return this.data.title ?? this.data.form.name;
  }

  // Form listener callbacks (mirrors ComponentHandlerComponent's onCancle/onSuccessfullySubmitted)
  onCancle(_form: Form): void {
    this.dialogRef.close();
  }

  onSuccessfullySubmitted(_form: Form): void {
    this.dialogRef.close(true);
  }
}
